import React, { FunctionComponent, memo, useMemo } from 'react';
import { PaginationProps } from 'antd/lib/pagination';
import { Dropdown, Pagination, Spin } from 'antd';
import IUser from '@interfaces/IUser';
import { goTo } from '@helpers/navigation';
import UserShortCard from '@components/UserShortCard';
import css from '@components/ComplaintsList/ComplaintsList.module.less';

interface ComplaintsListProps {
  parentEntityID: number | string;
  items: Array<IUser | { id: string | number; text: string }>;
  pagination?: PaginationProps;
  isListLoading: boolean;
  children: React.ReactNode;
  onOpen: (value: boolean) => void;
  onPagination?: (page: number) => void;
}

const ComplaintsList: FunctionComponent<ComplaintsListProps> = (props) => {
  const { parentEntityID, items, pagination, isListLoading, onOpen, onPagination, children } =
    props;

  const handleOpen = (value: boolean) => {
    onOpen(value);
  };

  const paginationChange = (page: number) => {
    if (onPagination) {
      onPagination(page);
    }
  };

  const handleRedirectToProfile = (user: IUser) => () => goTo('userDetail', { userId: user.id });

  const content = useMemo(() => {
    return (
      <div className={css.root}>
        <Spin spinning={isListLoading}>
          <div className={css.list}>
            {items.map((item) => {
              if ('nickname' in item) {
                return (
                  <UserShortCard
                    key={item.id}
                    user={item}
                    onClick={handleRedirectToProfile(item)}
                  />
                );
              }
              return (
                <div
                  className={css.item}
                  key={item.id}
                >
                  {item.text}
                </div>
              );
            })}
          </div>
          {pagination && (
            <div className={css.pagination}>
              <Pagination
                size='small'
                {...pagination}
                onChange={paginationChange}
              />
            </div>
          )}
        </Spin>
      </div>
    );
  }, [isListLoading, items]);

  return (
    <Dropdown
      key={parentEntityID}
      overlay={content}
      trigger={['click']}
      onVisibleChange={handleOpen}
    >
      {children}
    </Dropdown>
  );
};

export default memo(ComplaintsList);
